import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/header/Header";
import Sidebar from "../../components/sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import { getDashboardCounts } from "../../api/apiHandler";
import {
  showMessage,
  showErrorMessage,
  convertUTCToLocal,
} from "../common/Utils";
import enUS from "date-fns/locale/en-US";

export function Dashboard() {

  const today = new Date();
  let navigate = useNavigate();
  const auth = localStorage.getItem("token");
  // Redirect to login if not logged in
  if (!auth) {
    navigate("/login");
  }

  // 🟡 New state for picker visibility
  const [showPicker, setShowPicker] = useState(false);
  const [label, setLabel] = useState("FILTER - ALL TIME");
  const [dateFilter, setDateFilter] = useState({ startdate: "", enddate: "" });
  const [dashboard, setDashboard] = useState({
    users_counts: 0,
    orders_counts: 0,
    depositwithdrawals_counts: 0,
    earnings_counts: 0,
    notifications_counts: 0,
    contactus_counts: 0,
    faqs_counts: 0,
  });

  // 🟡 New state to store selected date range
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // 🟡 Close picker on outside click
  const pickerRef = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch data from server
  const fetchData = async () => {
    try {
      const userReq = {
        startdate: dateFilter.startdate,
        enddate: dateFilter.enddate,
      };
      const response = await getDashboardCounts(userReq);
      if (parseInt(response.code) === 1) {
        setDashboard(response.data);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Something went wrong getting dashboard counts, please try again later");
    }
  };

  // Initial data fetched
  useEffect(() => {
    fetchData();
  }, [ dateFilter ]);

  // 🟡 Handle date selection
  const handleSelect = (ranges) => {
    setRange([ranges.selection]);
    console.log("Selected Range: ", ranges.selection);
    const formattedLabel = `${ranges.selection.startDate.toDateString()} - ${ranges.selection.endDate.toDateString()}`;
    let utcStart = toPostgresLocal(ranges.selection.startDate);
    let utcEnd = toPostgresLocal(ranges.selection.endDate);
    setDateFilter({ startdate: utcStart, enddate: utcEnd });
    setLabel(formattedLabel);
    setShowPicker(false);
  };

  const toPostgresUTC = (date) => {
    const pad = (n) => n.toString().padStart(2, '0');
    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
  };

  const toPostgresLocal = (date) => {
    const pad = (n) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  };
  

  return (
    <>
      <Header />
      <Sidebar />
      <section className="content home">
        <div style={{ minHeight: 'calc(100vh - 130px)' }}>
          <div className="block-header">
            <div className="row align-items-center justify-content-between">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <h2>
                  Dashboard
                  <small className="text-muted">
                    Welcome to Alchemy Markets
                  </small>
                </h2>
              </div>
              <div
                className="col-lg-6 col-md-6 col-sm-12 text-right"
                style={{ position: "relative" }}
              >
                <button
                  className="btn btn-primary"
                  onClick={() => setShowPicker(!showPicker)}
                >
                  {label}
                </button>

                {showPicker && (
                  <div
                    ref={pickerRef}
                    style={{
                      position: "absolute",
                      top: "50px",
                      right: 0,
                      zIndex: 999,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                    }}
                  >
                    <DateRangePicker
                      locale={enUS}
                      ranges={range}
                      onChange={handleSelect}
                      showSelectionPreview={true}
                      moveRangeOnFirstSelection={false}
                      months={2}
                      direction="horizontal"
                      maxDate={today}
                      // staticRanges={[]}    // <--- hides sidebar presets like "Today", "This Week"
                      inputRanges={[]}     // <--- removes "days up to" / "days starting"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row clearfix">
              <div className="col-lg-3 col-sm-6 col-md-6">
                <a href="/authpanel/users/listing">
                  <div className="card l-red lightSpeedIn animated animated-slow">
                    <div className="body text-white">
                      <i
                        className="zmdi zmdi-accounts text-custom"
                        style={{
                          padding: "20px 30px",
                          fontSize: "60px",
                          position: "absolute",
                          right: "0px",
                          bottom: "0px",
                          top: "0px",
                          lineHeight: "60px",
                        }}
                      ></i>
                      <h2 className="m-t-0" id="users_counts">
                        {dashboard.users_counts}
                      </h2>
                      <p className="m-b-0">USERS</p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-sm-6 col-md-6">
                <a href="/authpanel/orders/listing">
                  <div className="card l-red lightSpeedIn animated animated-slow">
                    <div className="body text-white">
                      <i
                        className="zmdi zmdi-shopping-cart-plus text-custom"
                        style={{
                          padding: "20px 30px",
                          fontSize: "60px",
                          position: "absolute",
                          right: "0px",
                          bottom: "0px",
                          top: "0px",
                          lineHeight: "60px",
                        }}
                      ></i>
                      <h2 className="m-t-0" id="orders_counts">
                        {dashboard.orders_counts}
                      </h2>
                      <p className="m-b-0">ORDERS</p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-sm-6 col-md-6">
                <a href="/authpanel/deposit-withdrawal/listing">
                  <div className="card l-red lightSpeedIn animated animated-slow">
                    <div className="body text-white">
                      <i
                        className="zmdi zmdi-money-box text-custom"
                        style={{
                          padding: "20px 30px",
                          fontSize: "60px",
                          position: "absolute",
                          right: "0px",
                          bottom: "0px",
                          top: "0px",
                          lineHeight: "60px",
                        }}
                      ></i>
                      <h2 className="m-t-0" id="depositwithdrawals_counts">
                        {dashboard.depositwithdrawals_counts}
                      </h2>
                      <p className="m-b-0">DEPOSIT/WITHDRAWALS</p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-sm-6 col-md-6">
                <a href="/authpanel/earnings/listing">
                  <div className="card l-red lightSpeedIn animated animated-slow">
                    <div className="body text-white">
                      <i
                        className="zmdi zmdi-money text-custom"
                        style={{
                          padding: "20px 30px",
                          fontSize: "60px",
                          position: "absolute",
                          right: "0px",
                          bottom: "0px",
                          top: "0px",
                          lineHeight: "60px",
                        }}
                      ></i>
                      <h2 className="m-t-0" id="earnings_counts">
                        {dashboard.earnings_counts}
                      </h2>
                      <p className="m-b-0">EARNINGS</p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-sm-6 col-md-6">
                <a href="/authpanel/notifications/listing">
                  <div className="card l-red lightSpeedIn animated animated-slow">
                    <div className="body text-white">
                      <i
                        className="zmdi zmdi-notifications-active text-custom"
                        style={{
                          padding: "20px 30px",
                          fontSize: "60px",
                          position: "absolute",
                          right: "0px",
                          bottom: "0px",
                          top: "0px",
                          lineHeight: "60px",
                        }}
                      ></i>
                      <h2 className="m-t-0" id="notifications_counts">
                        {dashboard.notifications_counts}
                      </h2>
                      <p className="m-b-0">NOTIFICATIONS</p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-sm-6 col-md-6">
                <a href="/authpanel/contactus/listing">
                  <div className="card l-red lightSpeedIn animated animated-slow">
                    <div className="body text-white">
                      <i
                        className="zmdi zmdi-star text-custom"
                        style={{
                          padding: "20px 30px",
                          fontSize: "60px",
                          position: "absolute",
                          right: "0px",
                          bottom: "0px",
                          top: "0px",
                          lineHeight: "60px",
                        }}
                      ></i>
                      <h2 className="m-t-0" id="contactus_counts">
                        {dashboard.contactus_counts}
                      </h2>
                      <p className="m-b-0">CONTACT US</p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-sm-6 col-md-6">
                <a href="/authpanel/faqs/listing">
                  <div className="card l-red lightSpeedIn animated animated-slow">
                    <div className="body text-white">
                      <i
                        className="zmdi zmdi-help text-custom"
                        style={{
                          padding: "20px 30px",
                          fontSize: "60px",
                          position: "absolute",
                          right: "0px",
                          bottom: "0px",
                          top: "0px",
                          lineHeight: "60px",
                        }}
                      ></i>
                      <h2 className="m-t-0" id="faqs_counts">
                        {dashboard.faqs_counts}
                      </h2>
                      <p className="m-b-0">FAQs</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row clearfix footersticker">
            <div className="col-lg-12">
              <div className="card">
                <div className="body">
                  <p className="m-b-0">
                    ©2025 |{" "}
                    <a href="/authpanel/dashboard">Alchemy Markets Admin</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
